import bindAllOfThis from 'src/utils/BindThisHelper';
import { EndGameScene } from './EndGameScene';
import { GroceryItem } from '../objects/GroceryItem';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;

    bag: Phaser.GameObjects.Sprite;
    scanner: Phaser.GameObjects.Sprite;
    price: Phaser.GameObjects.Sprite;
    items: GroceryItem[];
    currentId: number;

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
    }

    preload(): void {
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/grocery_bagger.json"));
        this.load.image('background', require('/src/assets/qci/backgrounds/pkc_background.png'));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameGroceryBagger.png"), require("src/assets/qci/atlas/gameGroceryBagger.json"));
    }

    initialize(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.items = [];
        this.currentId = 1;
    }

    create(): void {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        this.createItems();
        this.createScene();
        this.registerEvents();
        this.moveItems();
    }

    createScene() {
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "bag") {
                this.bag = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "bag1");
                this.bag.name = "bag";
                this.bag.setInteractive();
                this.bag.input.dropZone = true;
            }
            else if (ob.name === "scanner") {
                this.scanner = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "scanner1");
                this.scanner.setInteractive();
                this.scanner.name = "scanner";

                this.scanner.setDisplaySize(ob.width, ob.height);
                this.scanner.input.dropZone = true;

                this.anims.create({
                    key: "scan",
                    frames: [
                        { key: 'assets', frame: 'scanner2', duration: 100 },
                        { key: 'assets', frame: 'scanner1' },
                    ],
                    frameRate: 2,
                });
            }
            else if (ob.name === "price") {
                this.price = this.add.sprite(ob.x, ob.y, 'assets', 'price');
                this.price.setOrigin(0);
                this.price.setAlpha(0);
            }
        });
    }

    createItems() {
        this.map.getObjectLayer("Items").objects.forEach((ob: TiledGameObject) => {
            var item = new GroceryItem(this, ob);
            this.items.push(item);
        });
    }

    registerEvents(): void {
        this.input.dragDistanceThreshold = 10;

        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, item: GroceryItem) => {
            if (item.id !== this.currentId) {
                return;
            }
            this.children.bringToTop(item);
            pointer.x = item.x;
            pointer.y = item.y;
        });

        this.input.on('dragenter', (pointer: Phaser.Input.Pointer, item: GroceryItem, dropzone) => {
            if (item.id !== this.currentId) {
                return;
            }
            if (dropzone.name === "scanner") {
                this.scanItem(item);
            }
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, item: GroceryItem, dragX: number, dragY: number) => {
            if (item.id !== this.currentId) {
                return;
            }
            item.x = pointer.x;
            item.y = pointer.y;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, item: GroceryItem, dropped: boolean) => {
            if (!dropped) {
                // Put back
                item.x = item.input.dragStartX;
                item.y = item.input.dragStartY;
            }
        });

        this.input.on('drop', (pointer: Phaser.Input.Pointer, item: GroceryItem, zone) => {
            if (zone.name === "scanner") {
                item.x = item.input.dragStartX;
                item.y = item.input.dragStartY;
                return;
            }
            if (item.id !== this.currentId) {
                return;
            }
            this.drop(item);
        });
    }

    scanItem(item: GroceryItem) {
        item.scanned = true;
        this.scanner.anims.play('scan', true);
        
        if (this.tweens.isTweening(this.price)) {
            this.tweens.killTweensOf(this.price);
        }

        this.tweens.add({
            targets: this.price,
            duration: 500,
            x: this.price.x,
            onStart: () => {
                this.price.setAlpha(1);
            },
            onComplete: () => {
                this.price.setAlpha(0);
            }
        });
    }

    moveItems() {
        this.input.enabled = false;
        this.tweens.add({
            targets: this.items.filter((i: GroceryItem) => !i.bagged),
            duration: 1000,
            x: "+= 200",
            onComplete: () => {
                this.input.enabled = true;
            }
        });
    }

    drop(item: GroceryItem) {
        this.children.bringToTop(item);

        if (!item.scanned) {
            item.x = item.input.dragStartX;
            item.y = item.input.dragStartY;
            return;
        }

        item.setVisible(false);
        item.bagged = true;
        item.input.enabled = false;

        this.currentId++;

        this.moveItems();

        if (this.currentId >= 8) {
            this.bag.setFrame("bag3");
        }
        else if (this.currentId >= 4) {
            this.bag.setFrame("bag2");
        }

        this.isGameOver();
    }

    isGameOver(): boolean {
        var item: GroceryItem;

        for (item of this.items) {
            if (!item.scanned && !item.bagged) {
                return false;
            }
        }

        // Wait a second and then end the game
        setTimeout(() => {
            this.scene.add("EndGameScene", EndGameScene, true);
            this.scene.remove(this);
        }, 1000);

        return true;
    }

}



// WEBPACK FOOTER //
// ./src/games/GroceryBaggerGame/scenes/MainScene.ts